// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071906/js/" + chunkId + "." + {"44":"5887d805","225":"e5fb7da7","481":"99553bc7","486":"549e4b86","770":"8d43a912"}[chunkId] + ".0.0453691368696062.chunk.js";
};